import React from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Astrologers from "./pages/Astrologers";
import Transactions from "./pages/Transactions";
import Calls from "./pages/Calls";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="sidebar">
        <h2>Astrologers Admin</h2>
        <NavLink to="/" end>Dashboard</NavLink>
        <NavLink to="/users">Users</NavLink>
        <NavLink to="/astrologers">Astrologers</NavLink>
        <NavLink to="/calls">Calls</NavLink>
        <NavLink to="/transactions">Transactions</NavLink>
      </div>

      <div className="main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/astrologers" element={<Astrologers />} />
          <Route path="/calls" element={<Calls />} />
          <Route path="/transactions" element={<Transactions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;